import { lazyPage } from "@core/app/lazyPage";
import type { WebModule } from "@modules/registry";

const AddressesPage = lazyPage(() => import("./pages/AddressesPage"), "AddressesPage");
const LoginPage = lazyPage(() => import("./pages/LoginPage"), "LoginPage");
const ProfilePage = lazyPage(() => import("./pages/ProfilePage"), "ProfilePage");

export const authModule: WebModule = {
  id: "auth",
  nav: null,
  routes: [
    { path: "/profile", element: <ProfilePage /> },
    { path: "/addresses", element: <AddressesPage /> },
  ],
  publicRoutes: [{ path: "/login", element: <LoginPage /> }],
};
